<!-- Encabezado principal -->
<div class="card">
  <!-- Header con título y botones -->
  <div class="d-flex justify-content-between align-items-center p-3 text-white"
       style="background-color: #2D3E50; border-radius: 0.5rem 0.5rem 0 0; min-height: 60px;">
    <span class="fw-bold fs-5">
      <i class="fas fa-chart-bar"></i> Reportes Programados
    </span>
    <div>
      <p-button label="Agregar" icon="pi pi-plus" (click)="agregarReporteProgramado0();" class="p-button-sm p-button-secondary mx-1"></p-button>
      <p-button label="Ejecutar" icon="pi pi-play" (click)="enviarCorreoReporteProgramado();" class="p-button-sm p-button-warning mx-1"></p-button>
    </div>
  </div>

  <!-- Spinner de carga -->
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" name="loadingReportesProgramados" size="medium" color="#fff" type="ball-pulse" [fullScreen]="false">
    <p style="color: white" class="text-center">{{ fullScreenSpinnerMsg }}</p>
  </ngx-spinner>

  <!-- Tabla de reportes programados -->
  <div class="p-fluid px-3">
    <p-table [value]="repProgramadosService.reportesProgramados" [tableStyle]="{ 'min-width': '80rem', 'font-size': '0.9rem' }" styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr class="bg-light text-dark">
          <th style="text-align: center; width:5%">N°</th>
          <th style="text-align: center; width:20%">Reporte</th>
          <th style="text-align: center; width:15%">Nombre del Reporte</th>
          <th style="text-align: center; width:10%">Último Generado</th>
          <th style="text-align: center; width:10%">Formato</th>
          <th style="text-align: center; width:10%">Vehículos</th>
          <th style="text-align: center; width:10%">Intervalo</th>
          <th style="text-align: center; width:10%">Próximo Reporte</th>
          <th style="text-align: center; width:10%">Opciones</th>
        </tr>
      </ng-template>
      
      <ng-template pTemplate="body" let-reporteProgramado let-rowIndex="rowIndex">
        <tr>
          <td class="text-center fw-bold">{{ rowIndex + 1 }}</td>
          <td class="text-center">{{ reporteProgramado.nombre_reporte }}</td>
          <td class="text-center">{{ reporteProgramado.nombre_programacion || '-' }}</td>
          <td class="text-center">{{ reporteProgramado.fecha_ultimo_reporte_generado ? (reporteProgramado.fecha_ultimo_reporte_generado | date:'yyyy-MM-dd HH:mm') : '-' }}</td>
          <td class="text-center"><span class="badge bg-success text-white">{{ reporteProgramado.formato_exportacion }}</span></td>
          <td class="text-center">{{ reporteProgramado.vehiculos_str }}</td>
          <td class="text-center"><span class="badge bg-info text-white">{{ reporteProgramado.intervalo }}</span></td>
          <td class="text-center">{{ reporteProgramado.proximo_reporte_generado_2 ? (reporteProgramado.proximo_reporte_generado_2 | date:'yyyy-MM-dd HH:mm') : '-' }}</td>
          <td class="text-center">
            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-info p-button-sm mx-1" pTooltip="Editar" (click)="editReporteProgramado(reporteProgramado)"></button>
            <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-success p-button-sm mx-1" pTooltip="Ver Detalle" (click)="verDetalleReporteProgramado(reporteProgramado)"></button>
            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-sm mx-1" pTooltip="Eliminar" (click)="EliminarReporteProgramado(reporteProgramado)"></button>
          </td>
        </tr>
      </ng-template>
      
      <!-- Template opcional para cuando no hay datos -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9" class="text-center p-4">
            No hay reportes programados disponibles.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>